export { AllysAboutSkeleton } from './AllysAboutSkeleton';
export { AllysAreaSkeleton } from './AllysAreaSkeleton';
export { AllysArticleSkeleton } from './AllysArticleSkeleton';
export { AllysContactSkeleton } from './AllysContactSkeleton';
export { AllysHomeSkeleton } from './AllysHomeSkeleton';
export { AllysNavSkeleton } from './AllysNavSkeleton';
export { AllysNewsSkeleton } from './AllysNewsSkeleton';
export { AllysProjectDetailSkeleton } from './AllysProjectDetailSkeleton';
export { AllysProjectsSkeleton } from './AllysProjectsSkeleton';
export { AllysPropertiesSkeleton } from './AllysPropertiesSkeleton';
export { AllysPropertyDetailSkeleton } from './AllysPropertyDetailSkeleton';
